import React from 'react';
import { react2panel } from 'common/util/react2panel';

// eslint-disable-next-line import/no-cycle
import { QueryEntrySectionReact } from './index';
import type { QueryEntrySectionProps } from './types';
export const QueryEntrySectionEl = react2panel("mp-query-entry-section", (props: QueryEntrySectionProps) => <QueryEntrySectionReact {...props} />);